import template   from './maintenance.html'

let component = {
  restrict: 'E',
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/maintenance/maintenance.component.js